import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";
import LegalShell from "../components/LegalShell";

export default function Terms() {
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <LegalShell title="Terms of Service" subtitle="Last updated: February 2026">
        <p>
          By using VibeCheck you agree to these terms. Please read them — they're
          short and matter.
        </p>

        <h2>1. Eligibility · 18+ only</h2>
        <p>
          VibeCheck is for adults aged <b>18 and over</b>. Some packs contain
          mature, flirty, or sexual content. By using the app you confirm you are
          at least 18 years old.
        </p>

        <h2>2. The vibe</h2>
        <p>
          VibeCheck is for <b>entertainment purposes only</b>. It's a game between
          two consenting adults — typically partners. We are not a substitute for
          therapy, relationship counselling, or medical advice.
        </p>

        <h2>3. No abuse, no harassment, no illegal content</h2>
        <p>
          You agree not to use VibeCheck to harass, threaten, exploit, or send
          abusive content to anyone. You agree not to record or share content
          involving minors, non-consenting parties, or illegal activity. We will
          terminate accounts and cooperate with authorities for clear violations.
        </p>

        <h2>4. Your content</h2>
        <p>
          Voice notes, videos, and typed answers you create stay between you and
          your partner. View-once videos are deleted from our servers after your
          partner watches them. We don't share, repost, or train AI models on your
          content.
        </p>

        <h2>5. Purchases</h2>
        <ul>
          <li>
            All payments are processed by Stripe. Prices are listed in USD unless
            stated otherwise.
          </li>
          <li>
            Digital purchases (packs, bundles, subscriptions) are{" "}
            <b>generally non-refundable</b> once the unlock has been delivered.
            See our{" "}
            <a href="/refund-policy">Refund Policy</a> for details.
          </li>
          <li>
            Subscriptions auto-renew until cancelled. You can cancel any time from
            your Stripe receipt or by emailing us.
          </li>
          <li>
            Intro pricing is one-per-account/device and time-limited. We won't grant
            it after the timer has expired.
          </li>
        </ul>

        <h2>6. Service availability</h2>
        <p>
          We try to keep VibeCheck running smoothly, but we don't guarantee
          uninterrupted service. We may pause, modify, or discontinue features at
          any time.
        </p>

        <h2>7. Liability</h2>
        <p>
          To the extent permitted by law, VibeCheck and its team are not liable for
          indirect, incidental, or consequential damages arising from your use of
          the service. Total liability is limited to what you paid us in the past
          12 months.
        </p>

        <h2>8. Changes to these terms</h2>
        <p>
          We may update these terms occasionally. The "Last updated" date will
          change, and material changes will be announced in-app. Continued use
          means you accept the updated terms.
        </p>

        <h2>9. Contact</h2>
        <p>
          Questions or concerns? Email{" "}
          <a href="mailto:playvibcheck@gmail.com">
            playvibcheck@gmail.com
          </a>
          .
        </p>
      </LegalShell>
      <Footer />
      <BottomTabBar />
    </div>
  );
}
